import { useEffect } from 'react';

// One-time coaching overlay that teaches the swipe gesture on the swipe screen.
// Sits over the card; dismisses on tap or on the first swipe. The buttons below
// remain the always-on affordance — this just teaches the drag.
export default function SwipeCoach({ onDismiss }) {
  useEffect(() => {
    const t = setTimeout(onDismiss, 9000); // auto-dismiss fallback
    return () => clearTimeout(t);
  }, [onDismiss]);

  return (
    <div
      className="absolute inset-0 z-30 flex flex-col items-center justify-center rounded-[1.25rem] cursor-pointer select-none"
      style={{ background: 'rgba(3,7,18,0.74)', backdropFilter: 'blur(2px)' }}
      onClick={onDismiss}
      role="button"
      aria-label="Got it, dismiss swipe hint"
    >
      <div className="flex items-center justify-between w-full px-5">
        {/* Skip (left) */}
        <div className="flex flex-col items-center gap-1 text-red-400 w-16">
          <svg className="w-7 h-7" fill="none" viewBox="0 0 24 24" strokeWidth={2.5} stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" d="M10.5 19.5 3 12m0 0 7.5-7.5M3 12h18" />
          </svg>
          <span className="font-display text-xs font-bold">Skip</span>
        </div>

        {/* Animated mini-card rocking left↔right */}
        <div className="animate-swipe-hint">
          <div className="w-11 h-16 rounded-lg border-2 border-lime bg-surface shadow-glow-sm flex items-center justify-center">
            <span className="text-lg" aria-hidden="true">🍽️</span>
          </div>
        </div>

        {/* Like (right) */}
        <div className="flex flex-col items-center gap-1 text-mint w-16">
          <svg className="w-7 h-7" fill="none" viewBox="0 0 24 24" strokeWidth={2.5} stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" d="M13.5 4.5 21 12m0 0-7.5 7.5M21 12H3" />
          </svg>
          <span className="font-display text-xs font-bold">Like</span>
        </div>
      </div>

      <p className="font-body text-sm text-ink text-center mt-7 px-8 leading-relaxed">
        Swipe the card <span className="text-mint font-semibold">right to like</span> or{' '}
        <span className="text-red-400 font-semibold">left to skip</span>, or tap the buttons below.
      </p>
      <span className="font-body text-xs text-ink-soft mt-3">Tap to dismiss</span>
    </div>
  );
}
